astral-accordion {
  display: flex;
  flex-direction: column;

  &[color='primary'] {
    .panel {
      &.opened {
        .header {
          background-color: rgba(var(--astral-primary-color));
          color: rgba(var(--astral-primary-contrast-color));
        }
      }
      &.stroked {
        .header {
          border: 1px solid rgba(var(--astral-primary-color));
        }
      }
      .header {
        &:hover {
          background: rgba(var(--astral-primary-color));
          color: rgba(var(--astral-primary-contrast-color));
        }
      }
    }
  }
  &[color='secondary'] {
    .panel {
      &.opened {
        .header {
          background-color: rgba(var(--astral-secondary-color));
          color: rgba(var(--astral-secondary-contrast-color));
        }
      }
      &.stroked {
        .header {
          border: 1px solid rgba(var(--astral-secondary-color));
        }
      }
      .header {
        &:hover {
          background: rgba(var(--astral-secondary-color));
        }
      }
    }
  }
  &[color='success'] {
    .panel {
      &.opened {
        .header {
          background-color: rgba(var(--astral-success-color));
          color: rgba(var(--astral-success-contrast-color));
        }
      }
      &.stroked {
        .header {
          border: 1px solid rgba(var(--astral-success-color));
        }
      }
      .header {
        &:hover {
          background: rgba(var(--astral-success-color));
        }
      }
    }
  }
  &[color='warning'] {
    .panel {
      &.opened {
        .header {
          background-color: rgba(var(--astral-warning-color));
          color: rgba(var(--astral-warning-contrast-color));
        }
      }
      &.stroked {
        .header {
          border: 1px solid rgba(var(--astral-warning-color));
        }
      }
      .header {
        &:hover {
          background: rgba(var(--astral-warning-color));
        }
      }
    }
  }
}
